// extracted by mini-css-extract-plugin
export var avatarContainer = "_f1-0";
export var gray = "_f1-f";
export var green = "_f1-c";
export var icon = "_f1-9";
export var image = "_f1-1";
export var lg = "_f1-6";
export var md = "_f1-5";
export var presenceDot = "_f1-b";
export var red = "_f1-d";
export var sm = "_f1-4";
export var status = "_f1-a";
export var xl = "_f1-7";
export var xs = "_f1-3";
export var xxl = "_f1-8";
export var xxs = "_f1-2";
export var yellow = "_f1-e";